function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function sanitizeTitleCandidate(raw?: string | null): string | null {
  if (!raw) return null;

  const decoded = safeDecode(raw)
    .replace(/\\/g, "/")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)
    .pop() ?? "";

  const noExt = decoded.replace(/\.[a-z0-9]{2,5}$/i, "");

  const cleaned = noExt
    .replace(/^asset[_-]?/i, "")
    .replace(/[\[\](){}]/g, " ")
    .replace(/[._-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!cleaned) return null;

  const filteredTokens = cleaned
    .split(" ")
    .filter(Boolean)
    .filter((token) => !/^\d{6,}$/.test(token))
    .filter((token) => !/^[0-9a-f]{8,}$/i.test(token))
    .filter((token) => !/^(asset|omnicine|library)$/i.test(token));

  const looksLikeHexShardId =
    filteredTokens.length >= 2 &&
    filteredTokens.every((token) => /^[0-9a-f]{4,}$/i.test(token)) &&
    filteredTokens.join("").length >= 12;
  if (looksLikeHexShardId) return null;

  if (filteredTokens.length > 2 && /^(audio|video|image)$/i.test(filteredTokens[0])) {
    filteredTokens.shift();
  }

  const normalizedTokens = (filteredTokens.length ? filteredTokens : cleaned.split(" ").filter(Boolean)).slice(0, 6);

  return normalizedTokens.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

export function resolveMediaIdentityTitle(args: {
  clipTitle?: string | null;
  assetDisplayName?: string | null;
  importedLabel?: string | null;
  mediaUrl?: string | null;
  mediaId?: string | null;
  kind?: "video" | "audio" | "image" | "unknown" | string;
}): string {
  const resolved =
    sanitizeTitleCandidate(args.clipTitle) ??
    sanitizeTitleCandidate(args.assetDisplayName) ??
    sanitizeTitleCandidate(args.importedLabel) ??
    sanitizeTitleCandidate(args.mediaUrl) ??
    sanitizeTitleCandidate(args.mediaId);

  if (resolved) return resolved;

  const kind = String(args.kind ?? "").toLowerCase();
  if (kind === "audio") return "Untitled Audio";
  if (kind === "video") return "Untitled Video";
  if (kind === "image") return "Untitled Image";
  return "Untitled Media";
}
